import _taggedTemplateLiteral from "/vercel/path0/starters/gatsby/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

import "core-js/modules/esnext.promise.all-settled.js";
import _regeneratorRuntime from "/vercel/path0/starters/gatsby/node_modules/@babel/runtime/regenerator/index.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return a;
};

var __async = function __async(__this, __arguments, generator) {
  return new Promise(function (resolve, reject) {
    var fulfilled = function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };

    var rejected = function rejected(value) {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };

    var step = function step(x) {
      return x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    };

    step((generator = generator.apply(__this, __arguments)).next());
  });
};

function buildCheckout(_ref) {
  var id = _ref.id,
      webUrl = _ref.webUrl;
  return {
    id: id,
    url: webUrl,
    completed: false
  };
}

function cartItemsToCheckoutItems(_ref2) {
  var cartItems = _ref2.cartItems;
  var lineItems = cartItems.map(function (cartItem) {
    var quantity = cartItem.quantity,
        providedVariantId = cartItem.variantId;
    var variantId = transformVariantIdToGid(providedVariantId);
    var customAttributes = metafieldsToCustomAttributes({
      metafields: cartItem.metafields
    });
    return {
      customAttributes: customAttributes,
      quantity: quantity,
      variantId: variantId
    };
  });
  return lineItems;
}

function sanitizeShopifyDomain(domain) {
  var _a, _b;

  var sanitizedDomain = (_b = (_a = domain == null ? void 0 : domain.split(".myshopify").shift()) == null ? void 0 : _a.split("//").pop()) == null ? void 0 : _b.split(".").pop();
  return sanitizedDomain || domain;
}

var fetchClientError = "[@nacelle/shopify-checkout] in order to create a checkout server-side, you must provide a fetch API-compatible `fetchClient` capable of running on both the client & server. Examples include `isomorphic-unfetch` and `cross-fetch`.";
var missingParametersErrorMessage = "[@nacelle/shopify-checkout]: missing required parameters. Either use both `myshopifyDomain` and `storefrontApiVersion`, or provide a `customEndpoint`.";

function createGqlClient(_ref3) {
  var customEndpoint = _ref3.customEndpoint,
      fetchClient = _ref3.fetchClient,
      myshopifyDomain = _ref3.myshopifyDomain,
      storefrontApiVersion = _ref3.storefrontApiVersion,
      storefrontCheckoutToken = _ref3.storefrontCheckoutToken;

  var gqlClient = function gqlClient(_ref4) {
    var query = _ref4.query,
        variables = _ref4.variables;
    var endpoint = customEndpoint;

    if (!endpoint) {
      if (!myshopifyDomain || !storefrontApiVersion) {
        throw new Error(missingParametersErrorMessage);
      }

      var domain = sanitizeShopifyDomain(myshopifyDomain || "");
      endpoint = "https://".concat(domain, ".myshopify.com/api/").concat(storefrontApiVersion, "/graphql");
    }

    var fetcher = fetchClient;

    if (!fetcher) {
      if (typeof window !== "undefined") {
        fetcher = window.fetch;
      } else {
        throw new Error(fetchClientError);
      }
    }

    return fetcher(endpoint, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": storefrontCheckoutToken
      },
      body: JSON.stringify({
        query: query,
        variables: variables
      })
    }).then(function (res) {
      return res.json();
    });
  };

  return gqlClient;
}

function gql(str) {
  for (var _len = arguments.length, values = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    values[_key - 1] = arguments[_key];
  }

  return str.reduce(function (acc, s, i) {
    return "".concat(acc).concat(s).concat(values[i] || "");
  }, "");
}

function handleShopifyError(errors) {
  var _ref5 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      caller = _ref5.caller,
      message = _ref5.message;

  var errorMessage = "";

  if (caller) {
    errorMessage = "[".concat(caller, "] ");
  }

  errorMessage = errorMessage + (message || "Shopify Storefront API Errors:") + (errors ? "\n" + JSON.stringify(errors, null, 2) : "");
  throw new Error(errorMessage);
}

function isVerifiedCheckoutId(id) {
  if (!(id == null ? void 0 : id.length)) {
    return false;
  }

  return id.includes("Z2lkOi8vc2hvcGlmeS9DaGVja291dC8") && id !== "";
}

function metafieldsToCustomAttributes(_ref6) {
  var metafields = _ref6.metafields;

  if (!Array.isArray(metafields) || !(metafields == null ? void 0 : metafields.length)) {
    return [];
  }

  var customAttributes = metafields == null ? void 0 : metafields.reduce(function (fields, m) {
    if (typeof m.value === "string") {
      fields.push({
        key: m.key,
        value: m.value
      });
    } else {
      console.warn("Omitting custom attribute \"".concat(m.key, "\" because it has a non-string value."));
    }

    return fields;
  }, []);
  return customAttributes;
}

function transformVariantIdToGid(variantId) {
  if (isPlainTextGlobalId(variantId)) {
    return variantId;
  }

  if (isNumeric(variantId)) {
    return idToVariantGid(variantId);
  }

  var decodedVariantId = decodeBase64Id(variantId);

  if (isPlainTextGlobalId(decodedVariantId)) {
    return decodedVariantId;
  }

  throw Error("".concat(variantId, " is an invalid shopify variant id"));
}

function isPlainTextGlobalId(variantId) {
  return variantId.startsWith("gid://shopify/");
}

function isNumeric(variantId) {
  return !Number.isNaN(Number(variantId));
}

function decodeBase64Id(variantId) {
  try {
    if (typeof window === "undefined") {
      if (Buffer.from(variantId, "base64").toString("base64") === variantId) {
        return Buffer.from(variantId, "base64").toString();
      } else {
        return variantId;
      }
    } else {
      return window.atob(variantId);
    }
  } catch (err) {
    return variantId;
  }
}

function idToVariantGid(variantId) {
  return "gid://shopify/ProductVariant/".concat(variantId);
}

var checkoutCreate = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["mutation checkoutCreate($input: CheckoutCreateInput!) { checkoutCreate(input: $input) { checkout { id webUrl } checkoutUserErrors { code field message } } }"])));
var checkoutLineItemsReplace$1 = gql(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["mutation checkoutLineItemsReplace( $lineItems: [CheckoutLineItemInput!]! $checkoutId: ID! ) { checkoutLineItemsReplace(lineItems: $lineItems, checkoutId: $checkoutId) { checkout { id webUrl } userErrors { code field message } } }"])));
var checkoutAttributesUpdate$1 = gql(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["mutation checkoutAttributesUpdate( $checkoutId: ID! $input: CheckoutAttributesUpdateV2Input! ) { checkoutAttributesUpdateV2(checkoutId: $checkoutId, input: $input) { checkout { id webUrl } checkoutUserErrors { code field message } } }"])));

function checkoutAttributesUpdate(_0) {
  return __async(this, arguments, /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref7) {
    var gqlClient, id, customAttributes, note, query, variables, _yield$gqlClient$catc, data, errors, errs;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            gqlClient = _ref7.gqlClient, id = _ref7.id, customAttributes = _ref7.customAttributes, note = _ref7.note;
            query = checkoutAttributesUpdate$1;
            variables = {
              checkoutId: id,
              input: {
                customAttributes: customAttributes,
                note: note
              }
            };
            _context.next = 5;
            return gqlClient({
              query: query,
              variables: variables
            }).catch(function (err) {
              throw new Error(err);
            });

          case 5:
            _yield$gqlClient$catc = _context.sent;
            data = _yield$gqlClient$catc.data;
            errors = _yield$gqlClient$catc.errors;
            errs = errors || (data == null ? void 0 : data.checkoutAttributesUpdateV2.checkoutUserErrors);

            if (errs == null ? void 0 : errs.length) {
              handleShopifyError(errs, {
                caller: "checkoutAttributesUpdate"
              });
            }

            if (!(data == null ? void 0 : data.checkoutAttributesUpdateV2.checkout)) {
              _context.next = 12;
              break;
            }

            return _context.abrupt("return", buildCheckout(data.checkoutAttributesUpdateV2.checkout));

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
}

function createCheckout(_0) {
  return __async(this, arguments, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref8) {
    var gqlClient, lineItems, customAttributes, note, queueToken, query, variables, _yield$gqlClient$catc2, data, errors, errs;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            gqlClient = _ref8.gqlClient, lineItems = _ref8.lineItems, customAttributes = _ref8.customAttributes, note = _ref8.note, queueToken = _ref8.queueToken;
            query = checkoutCreate;
            variables = {
              input: {
                customAttributes: customAttributes,
                lineItems: lineItems,
                note: note
              },
              queueToken: queueToken
            };
            _context2.prev = 3;
            _context2.next = 6;
            return gqlClient({
              query: query,
              variables: variables
            }).catch(function (err) {
              throw new Error(err);
            });

          case 6:
            _yield$gqlClient$catc2 = _context2.sent;
            data = _yield$gqlClient$catc2.data;
            errors = _yield$gqlClient$catc2.errors;
            errs = errors || (data == null ? void 0 : data.checkoutCreate.checkoutUserErrors);

            if (errs == null ? void 0 : errs.length) {
              handleShopifyError(errors, {
                caller: "checkoutCreate"
              });
            }

            if (!(data == null ? void 0 : data.checkoutCreate.checkout)) {
              _context2.next = 13;
              break;
            }

            return _context2.abrupt("return", buildCheckout(data.checkoutCreate.checkout));

          case 13:
            _context2.next = 18;
            break;

          case 15:
            _context2.prev = 15;
            _context2.t0 = _context2["catch"](3);
            throw new Error(String(_context2.t0));

          case 18:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[3, 15]]);
  }));
}

function checkoutLineItemsReplace(_0) {
  return __async(this, arguments, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref9) {
    var gqlClient, lineItems, id, query, variables, _yield$gqlClient$catc3, data, errors, errs;

    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            gqlClient = _ref9.gqlClient, lineItems = _ref9.lineItems, id = _ref9.id;
            query = checkoutLineItemsReplace$1;
            variables = {
              checkoutId: id,
              lineItems: lineItems
            };
            _context3.next = 5;
            return gqlClient({
              query: query,
              variables: variables
            }).catch(function (err) {
              throw new Error(err);
            });

          case 5:
            _yield$gqlClient$catc3 = _context3.sent;
            data = _yield$gqlClient$catc3.data;
            errors = _yield$gqlClient$catc3.errors;
            errs = errors || (data == null ? void 0 : data.checkoutLineItemsReplace.userErrors);

            if (errs == null ? void 0 : errs.length) {
              handleShopifyError(errs, {
                caller: "checkoutLineItemsReplace"
              });
            }

            if (!(data == null ? void 0 : data.checkoutLineItemsReplace.checkout)) {
              _context3.next = 12;
              break;
            }

            return _context3.abrupt("return", buildCheckout(data.checkoutLineItemsReplace.checkout));

          case 12:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
}

var getCheckout = gql(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["query getCheckout($id: ID!) { node(id: $id) { ... on Checkout { id webUrl completedAt } } }"])));

function findCheckout(_0) {
  return __async(this, arguments, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(_ref10) {
    var gqlClient, id, query, variables, _yield$gqlClient$catc4, data, errors, _data$node, id2, webUrl, completedAt;

    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            gqlClient = _ref10.gqlClient, id = _ref10.id;
            query = getCheckout;
            variables = {
              id: id
            };
            _context4.next = 5;
            return gqlClient({
              query: query,
              variables: variables
            }).catch(function (err) {
              throw new Error(err);
            });

          case 5:
            _yield$gqlClient$catc4 = _context4.sent;
            data = _yield$gqlClient$catc4.data;
            errors = _yield$gqlClient$catc4.errors;

            if (errors) {
              handleShopifyError(errors, {
                caller: "findCheckout"
              });
            }

            if (data == null ? void 0 : data.node) {
              _context4.next = 13;
              break;
            }

            handleShopifyError(void 0, {
              caller: "findCheckout",
              message: "Checkout response has no data"
            });
            _context4.next = 15;
            break;

          case 13:
            _data$node = data.node, id2 = _data$node.id, webUrl = _data$node.webUrl, completedAt = _data$node.completedAt;
            return _context4.abrupt("return", {
              completed: Boolean(completedAt),
              id: id2 || "",
              url: webUrl || ""
            });

          case 15:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
}

function putCheckout(_0) {
  return __async(this, arguments, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(_ref11) {
    var gqlClient, id, lineItems, customAttributes, note, queueToken, checkout, shouldUpdateLineItems, shouldUpdateAttributes, checkoutUpdatePromises;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            gqlClient = _ref11.gqlClient, id = _ref11.id, lineItems = _ref11.lineItems, customAttributes = _ref11.customAttributes, note = _ref11.note, queueToken = _ref11.queueToken;
            checkout = void 0;
            shouldUpdateLineItems = lineItems == null ? void 0 : lineItems.length;
            shouldUpdateAttributes = (customAttributes == null ? void 0 : customAttributes.length) || note;
            _context5.prev = 4;

            if (!id) {
              _context5.next = 13;
              break;
            }

            if (isVerifiedCheckoutId(id)) {
              _context5.next = 8;
              break;
            }

            throw new Error("Invalid checkout ID. Expected a Base64-encoded Shopify Global ID. Received: ".concat(id));

          case 8:
            checkoutUpdatePromises = [];

            if (shouldUpdateLineItems) {
              checkoutUpdatePromises.push(checkoutLineItemsReplace({
                gqlClient: gqlClient,
                id: id,
                lineItems: lineItems
              }));
            }

            if (shouldUpdateAttributes) {
              checkoutUpdatePromises.push(checkoutAttributesUpdate({
                gqlClient: gqlClient,
                id: id,
                customAttributes: customAttributes,
                note: note
              }));
            }

            _context5.next = 13;
            return Promise.allSettled(checkoutUpdatePromises).then(function (settledPromises) {
              return settledPromises.forEach(function (p) {
                if (p.status === "fulfilled" && p.value) {
                  checkout = __spreadValues(__spreadValues({}, checkout || {}), p.value);
                } else if (p.status === "rejected") {
                  throw new Error(p.reason);
                }
              });
            });

          case 13:
            if (!(typeof checkout === "undefined" && typeof lineItems !== "undefined")) {
              _context5.next = 17;
              break;
            }

            _context5.next = 16;
            return createCheckout({
              gqlClient: gqlClient,
              customAttributes: customAttributes,
              note: note,
              lineItems: lineItems,
              queueToken: queueToken
            });

          case 16:
            checkout = _context5.sent;

          case 17:
            return _context5.abrupt("return", checkout);

          case 20:
            _context5.prev = 20;
            _context5.t0 = _context5["catch"](4);
            throw new Error(String(_context5.t0));

          case 23:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, null, [[4, 20]]);
  }));
}

function createShopifyCheckoutClient(_ref12) {
  var storefrontCheckoutToken = _ref12.storefrontCheckoutToken,
      myshopifyDomain = _ref12.myshopifyDomain,
      storefrontApiVersion = _ref12.storefrontApiVersion,
      customEndpoint = _ref12.customEndpoint,
      fetchClient = _ref12.fetchClient;
  var gqlClient = createGqlClient({
    customEndpoint: customEndpoint,
    fetchClient: fetchClient,
    myshopifyDomain: myshopifyDomain,
    storefrontApiVersion: storefrontApiVersion,
    storefrontCheckoutToken: storefrontCheckoutToken
  });

  function getCheckout2(_0) {
    return __async(this, arguments, /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(_ref13) {
      var id;
      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              id = _ref13.id;
              _context6.next = 3;
              return findCheckout({
                gqlClient: gqlClient,
                id: id
              });

            case 3:
              return _context6.abrupt("return", _context6.sent);

            case 4:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));
  }

  function processCheckout(_0) {
    return __async(this, arguments, /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(_ref14) {
      var cartItems, id, metafields, note, queueToken, lineItems, customAttributes;
      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              cartItems = _ref14.cartItems, id = _ref14.id, metafields = _ref14.metafields, note = _ref14.note, queueToken = _ref14.queueToken;
              lineItems = (cartItems == null ? void 0 : cartItems.length) ? cartItemsToCheckoutItems({
                cartItems: cartItems
              }) : void 0;
              customAttributes = (metafields == null ? void 0 : metafields.length) ? metafieldsToCustomAttributes({
                metafields: metafields
              }) : void 0;
              _context7.next = 5;
              return putCheckout({
                gqlClient: gqlClient,
                lineItems: lineItems,
                id: id,
                customAttributes: customAttributes,
                note: note,
                queueToken: queueToken
              });

            case 5:
              return _context7.abrupt("return", _context7.sent);

            case 6:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }));
  }

  return {
    get: getCheckout2,
    process: processCheckout
  };
}

export { createShopifyCheckoutClient as default };